import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 0,
            gcTime: 1000 * 60 * 60 * 24, // 24 heures
            // Pas de nouvelle tentative automatique en cas d'échec (comme nec-front)
            retry: false,
        },
    },
});
